import { useSelectSlice } from "@common/redux/selectors/useSelectSlice"
import { eventsSlice } from "@common/redux/slices/entities.slice"
import { Layout } from "@kursk/components/Layout/Layout";
import styles from './Events.module.scss';
import { Filters } from "../../ui/Filters/Filters";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { Socials } from "../Home/Socials/Socials";
import { getEntitiesListTitle } from "@kursk/utils/getEntitiesListTitle";
import { EventsGrid } from "./EventsGrid/EventsGrid";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import { HeroBlock } from "@kursk/components/ui/HeroBlock/HeroBlock";
import { picksSlice } from "@common/redux/slices/picks";
import { LdJson } from "@kursk/components/seo/LdJson";
import React from "react";
import { CatalogueTitle } from "@kursk/components/ui/CatalogueTitle/CatalogueTitle";

export const Events = () => {
  const { total, meta, filters, items } = useSelectSlice(eventsSlice);
  const { listPlaces, forEventsOverviews } = useSelectSlice(recommendationSlice);
  const selectedTags = filters.allTags;
  const selectedTag = (meta.tags && selectedTags.length === 1) && meta.tags.find((tag) => tag._id === selectedTags[0]);
  const { bannersInCatalogs } = useSelectSlice(picksSlice);
  return (
    <Layout showSubscribePopup={false} page="events">
      {items.map(event => (
        <LdJson
          entity={event}
          type={'events'}
          key={event._id}
        />))
      }
      <SeoMetaTitles
        page="events"
        selectedTag={selectedTag}
        titleOg={getEntitiesListTitle(meta.tags, selectedTags)}
        meta={meta}
      />
      <HeroBlock banners={bannersInCatalogs} page="events"/>
      <section className={styles.section_content}>
        <div className={styles.header}>
          <CatalogueTitle
            page="events"
            tags={meta.tags}
            selectedTags={selectedTags}
            dashTitle={'Найдено событий'}
            total={total}
          />
        </div>
        <div className={styles.filters}>
          <Filters
            entityType={'events'}
            meta={meta}
            filters={filters}
            withLocales
            withPlaces
            withDates
            withPrices
            withPricesOptions={{
              withFreeCheckbox: true,
              withTicketsCheckbox: true,
              dropDownTitle: 'Цена (₽)'
            }}/>
        </div>
        <div className={styles.items}>
          <EventsGrid/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType="places"
            data={listPlaces}
            title={'Рекомендуем побывать'}
            goTo={'/places'}
            goToTitle={'все места'}/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType="overviews"
            data={forEventsOverviews}
            title={'Рекомендуем почитать'}
            goTo={'/overviews'}
            goToTitle={'все обзоры'}/>
        </div>
        <div className={styles.recommendationSection}>
          <SubscribeFooterForm/>
        </div>
        <div className={styles.section}>
          <Socials/>
        </div>
      </section>
    </Layout>
  );
}
